// i18n area 'apps' — locale de-DE (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.de-DE.meta.json.
import type { enUS } from './apps'

export const deDE: typeof enUS = {
  apps: {
    title: 'Apps',
    create: 'App erstellen',
    createTitle: 'App erstellen',
    editTitle: 'App bearbeiten',
    name: 'Name',
    nameHint: 'DNS-1123, eindeutig im Scope — nach der Erstellung unveränderlich.',
    node: 'Knoten',
    nodeHint: 'Der Mitgliedsknoten, der sie bedient — explizites Placement (der Scheduler kommt später).',
    image: 'Image',
    editImageHint: 'Eine neue Referenz wird über die Stammdaten neu aufgelöst — die Pin-/Rollback-Geste.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Der Digest bewegt sich nur auf Befehl.',
    policyTrackingHint: 'Rollt automatisch, wenn ein Refresh den Branch bewegt.',
    archMovePolicy: 'Cross-Arch-Verschiebung',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Was passiert, wenn die App auf einen Node einer anderen Architektur verschoben wird: refuse verweigert die Verschiebung, reresolve löst das Lockfile vom Branch auf der neuen Arch neu auf — der Inhalt ändert sich, und die Antwort benennt die Digest-Änderung.',
    network: 'Netzwerk',
    networkHint: 'Untagged-L3-Anbindung: ein logisches Fabric-Netzwerk (empfohlen — Gateway/DNS aus seiner einzigen Quelle), ein Overlay, oder eine nackte Host-Bridge (nicht empfohlen).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'Host-Bridge:',
    ipAssignment: 'IP-Zuweisung',
    ipStatic: 'Statisch',
    ipAuto: 'Automatisch (IPAM)',
    ipAssignmentHint_static: 'Die Adresse geben Sie an, jetzt.',
    ipAssignmentHint_auto: 'Das IPAM wählt eine freie Adresse aus den für TVirt reservierten Bereichen des Netzwerks.',
    bridgeDiscouraged: 'Nackte Host-Bridge — NICHT EMPFOHLEN: TVirt weiß nichts über ihre Adressierung, also müssen Gateway und DNS von Hand angegeben werden. Der empfohlene Weg ist ein logisches Fabric-Netzwerk.',
    ip: 'IP',
    ipHint: 'Statische IPv4 innerhalb des Subnetzes der Anbindung.',
    ipCidrHint: 'In CIDR-Form auf einer nackten Bridge (z. B. 192.168.1.10/24) — es gibt nichts, woraus sich das Präfix ableiten ließe.',
    gateway: 'Gateway',
    gatewayManualHint: 'Manuell — eine nackte Bridge leitet nichts ab.',
    dnsServers: 'DNS-Server',
    dnsManualHint: 'Manuell, kommagetrennt — mindestens einer.',
    rootKind: 'Root',
    rootEphemeral: 'ephemer',
    rootPersistent: 'persistent',
    rootEphemeralHint: 'Bei jeder Neuerstellung aus dem Image neu erzeugt; lebt auf dem ephemeren Cluster-Storage.',
    rootEphemeralHintNamed: 'Bei jeder Neuerstellung aus dem Image neu erzeugt; lebt auf dem ephemeren Cluster-Storage ({name}).',
    rootPersistentHint: 'Überlebt Neustarts; lebt auf dem Storage, den Sie wählen.',
    rootStorage: 'Root-Storage',
    editRootStorageHint: 'Die Root wird auf dem neuen Pool neu gerendert — vorhandene Daten ziehen NICHT von selbst um.',
    volumes: 'Volumes',
    volumeAdd: 'Volume hinzufügen',
    volumeName: 'Name',
    volumeMountPath: 'Mount-Pfad',
    volumeKind: 'Typ',
    volumeStorage: 'Storage',
    devices: 'Geräte',
    deviceClassHint: 'Man fordert eine KLASSE an (ein gpu-device- oder usb-device-Tag), nie ein bestimmtes Gerät: der deklarierte Knoten muss eines besitzen, das für die Apps markiert ist. Mehrere Apps können dasselbe Gerät nutzen — ein Container teilt es, er nimmt es dem Host nicht weg.',
    deviceSlot: 'Slot',
    deviceTag: 'Tag',
    deviceValue: 'Klasse',
    deviceUnresolved: 'derzeit wird nichts aufgelöst',
    noDeviceTags: 'Noch kein Tag der Art gpu-device oder usb-device: eines anlegen und den für die Apps markierten Geräten zuweisen.',
    env: 'Umgebung',
    envHint: 'Ein SCHLÜSSEL=wert pro Zeile.',
    secretEnvTitle: 'Geheime Variablen',
    secretEnvNotice: 'Ein geheimer Wert kommt nie wieder aus der API zurück: niemand liest ihn erneut, nicht einmal wer ihn geschrieben hat. Im Checkpoint reist er mit der Masterpass versiegelt, eine Wiederherstellung ohne Masterpass verlangt ihn also erneut.',
    secretEnvPromote: 'Machen Sie eine der oben geschriebenen Variablen geheim:',
    secretEnvAdd: 'Geheime Variable hinzufügen',
    secretEnvName: 'Name',
    secretEnvValue: 'Wert',
    secretEnvKept: 'bewahrt — leer lassen, um ihn unverändert zu lassen',
    secretEnvWithdrawWarning: 'Um eine bereits geheime Variable nicht mehr als geheim zu behandeln, schreiben Sie ihr einen neuen Wert: allein die Markierung zurückzunehmen wäre ein Weg, das zu LESEN, was den Store nie verlässt. Sie zu entfernen löscht sie dagegen.',
    secretEnvChip: 'geheim',
    startNow: 'Sofort starten (sonst kommt die App gestoppt zur Welt)',
    deletePersistentIntro: 'Diese App hat persistente Daten — wählen Sie, was damit geschieht:',
    deleteKeepData: 'Daten behalten (die Verzeichnisse bleiben verwaist auf ihren Storages)',
    deletePurgeData: 'Auch die Daten löschen',
    phase: 'Phase',
    phase_running: 'Läuft',
    phase_stopped: 'Gestoppt',
    phase_error: 'Fehler',
    phase_unknown: 'Unbekannt',
    desiredState: 'Gewollt',
    wantedRunning: 'laufend',
    wantedStopped: 'gestoppt',
    start: 'Starten',
    stop: 'Stoppen',
    restart: 'Neu starten',
    refreshImage: 'Image aktualisieren (das neue @current übernehmen)',
    logs: 'Logs',
    logsTitle: 'Logs',
    logsEmpty: 'Keine Ausgabe erfasst.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Die App läuft nicht — eine Shell braucht einen lebenden Container. Ihre Logs sind in jedem Zustand lesbar.',
    shellConnect: 'Verbinden',
    shellDisconnect: 'Trennen',
    shellExited: 'Die Sitzung endete mit Exit-Code {code}.',
    shellEndedWithoutStatus: 'Die Sitzung endete ohne Exit-Status: {reason}',
    shellRevoked: 'Das Ticket der Sitzung ist nicht mehr gültig — es ist abgelaufen, oder das Login, das es geöffnet hat, wurde widerrufen.',
    shellHint: 'Klicke in das schwarze Feld und tippe: die Tasten gehen an den Container. Ctrl+C und die Pfeiltasten funktionieren; exit schließt die Shell.',
    shellStatus: {
      connecting: 'Verbinde…',
      connected: 'Verbunden',
      ended: 'Beendet'
    },
    deleteRunningError: '{name} ist laufend gewollt — stoppen Sie sie zuerst.',
    tabs: {
      general: 'Allgemein',
      image: 'Image',
      network: 'Netzwerk',
      storage: 'Storage',
      devices: 'Geräte',
      observed: 'Beobachtet'
    },
    attachment: 'Anbindung',
    runningDigest: 'Laufender Digest',
    lastError: 'Letzter Fehler',
    reportObservedAt: 'Letzter Report des Workers',
    desiredStateLock: 'Wird von den Aktionen Starten/Stoppen bestimmt — nie eine direkte Bearbeitung.',
    ipEditDisabledHint: 'Nur bei statischer Zuweisung bearbeitbar.',
    derivedFromNetworkHint: 'Aus der einzigen Quelle des Netzwerks abgeleitet — manuell nur auf einer nackten Bridge mit statischer IP.',
    ephemeralUnset: 'nicht konfiguriert',
    ephemeralMissing: 'Der ephemere Storage der Apps ist nicht konfiguriert — das Erstellen einer App mit ephemeren Teilen (Root oder Volumes) wird abgelehnt, bis Sie ihn setzen.',
    ephemeralCurrent: 'Ephemerer Storage der Apps: {name}',
    ephemeralMissingCreate: 'Diese App hat ephemere Teile, aber der ephemere Storage der Apps ist nicht gesetzt — die Erstellung wird abgelehnt. Setzen Sie ihn zuerst über das Banner der Apps-Seite.',
    setEphemeral: 'Ephemeren Storage setzen',
    changeEphemeral: 'Ephemeren Storage ändern',
    setEphemeralTitle: 'Den ephemeren Storage der Apps setzen',
    changeEphemeralTitle: 'Den ephemeren Storage der Apps ändern',
    ephemeralStorageHint: 'Cluster-DEFAULT: der dir-like Pool, auf dem die ephemeren Roots und Volumes jeder App leben, sofern die App keinen eigenen Override deklariert. Eine Änderung greift nicht im laufenden Betrieb und startet nichts neu: Sie gilt ab dem nächsten Start jeder App — ephemere Daten ziehen nicht um.',
    ephemeralPool: 'Storage-Pool',
    ephemeralOverride: 'Ephemerer Storage (Override pro App)',
    ephemeralOverrideInherit: 'Den Cluster-Default erben',
    ephemeralOverrideInheritNamed: 'Den Cluster-Default erben ({name})',
    ephemeralOverrideHint: 'Pool pro App für ephemere Root und Volumes — leer lassen, um den Cluster-Default zu erben. Die Änderung greift nicht im laufenden Betrieb und startet nichts neu: Sie gilt ab dem nächsten Start (ephemere Daten werden leer auf dem neuen Pool wiedergeboren) und erfordert die Berechtigung app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Alle Branches',
    imageBranchHint: 'Schränkt die Images auf die von diesem Branch benannten ein; ohne Branch sieht man alle Images des Repositories.',
    imageDigestHint: 'Der Inhalt: er wird aus der Digest-Tabelle gewählt, die seine Herkunft und seine Architektur mitführt. Derselbe Branch bietet einen je Architektur, und sie sind nicht austauschbar.',
    imageLockfile: 'Aufgelöste Referenz',
    imageNoImages: 'Kein Image im Cache für dieses Repository — lade eines über OCI-Images herunter.',
    imageHeadNotCached: 'nicht im Cache — wird beim Start geholt',
    imageNoRegistries: 'Kein Repository registriert: registriere eines, um ein Image wählen zu können.',
    imageChosenHint: 'Das Image wird über die Kaskade im Bearbeiten-Dialog gewählt: die Referenz wird nie von Hand getippt.',
    registerRepositoryHint: 'Registrieren lädt nichts herunter: es macht ein Repository beobachtbar, damit das Image gewählt werden kann, ohne diesen Dialog zu verlassen.',
    registerRepositoryBranchHint: 'Optional: der erste zu beobachtende Branch (z. B. latest).',
    registerRepositoryElsewhere: 'Das gesuchte Repository ist nicht registriert: die Registrierung erfolgt im Bereich OCI-Images, durch jemanden mit der Berechtigung.'
  },
  cts: {
    createAction: 'CT erstellen',
    createTitle: 'Einen Container aus einem Template erstellen',
    createError: 'Der Container wurde nicht erstellt',
    template: 'CT-Template',
    noTemplates: 'Keine CT-Templates — importieren Sie eines unter CT-Templates',
    resources: 'Ressourcen',
    node: 'Knoten',
    phase: {
      defined: 'Nie eingeschaltet',
      materializing: 'Wird materialisiert',
      ready: 'Bereit',
      starting: 'Startet',
      running: 'Läuft',
      stopping: 'Wird gestoppt',
      stopped: 'Gestoppt',
      deleting: 'Wird gelöscht',
      error: 'Im Fehlerzustand'
    },
    actions: {
      start: 'Starten',
      stop: 'Stoppen',
      restart: 'Neu starten',
      markTemplate: 'Zum CT-Template befördern',
      error: 'Die Aktion wurde abgelehnt'
    },
    markTemplate: {
      confirmTitle: "'{name}' zum CT-Template befördern?",
      confirmBody: 'Der Container verlässt diese Liste und wechselt zu den CT-Templates, sofort bereit, neue CTs zu erzeugen. Seine Metadaten bleiben bearbeitbar, und Sie können ihn jederzeit wieder zum CT machen.',
      confirm: 'Befördern',
      moved: "'{name}' ist jetzt ein CT-Template — Sie finden es unter CT-Templates."
    },
    stopCause: {
      api: 'Über TVirt gestoppt',
      'ct-exit': 'Der Container hat sich von selbst beendet',
      'host-reboot': 'Mit dem Neustart des Knotens gestorben',
      'start-failed': 'Der Start ist fehlgeschlagen — der Fehler des Tasks sagt, was fehlt und wie es sich beheben lässt'
    },

    console: 'Konsole',
    consoleUnavailable: 'Der Container läuft nicht — eine Konsole braucht einen lebenden Container. Seine Logs dagegen lassen sich in jedem Zustand lesen.',
    consoleNoTemplate: 'Ein Template läuft nie, also hat es keine Konsole: Erstellen Sie daraus einen CT und öffnen Sie dessen Konsole.',
    consoleConnect: 'Verbinden',
    consoleDisconnect: 'Trennen',
    consoleReconnect: 'Neu verbinden',
    consoleTakenBy: 'Ein anderer Bediener hat diese Konsole übernommen ({user}). Eine Konsole pro Container: Neu verbinden holt sie zurück.',
    consoleHint: 'Klicken Sie in das schwarze Feld und tippen Sie: Die Tasten gehen an den Container. Strg+C und die Pfeiltasten funktionieren.',
    consoleEndpointDown: 'Der Zugangspunkt der Konsole lässt sich auf dem Knoten, der den Container bedient, nicht öffnen: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Der Container läuft nicht — eine Shell braucht einen lebenden Container. Seine Logs sind in jedem Zustand lesbar.',
    shellNoTemplate: 'Ein Template läuft nie, also hat es keine Shell: erstelle daraus einen CT und öffne dessen Shell.',
    shellConnect: 'Verbinden',
    shellDisconnect: 'Trennen',
    shellExited: 'Die Sitzung endete mit Exit-Code {code}.',
    shellEndedWithoutStatus: 'Die Sitzung endete ohne Exit-Status: {reason}',
    shellRevoked: 'Das Ticket der Sitzung ist nicht mehr gültig — es ist abgelaufen, oder das Login, das es geöffnet hat, wurde widerrufen.',
    shellHint: 'Klicke in das schwarze Feld und tippe: die Tasten gehen an den Container. Ctrl+C und die Pfeiltasten funktionieren; exit schließt die Shell.',
    shellStatus: {
      connecting: 'Verbinde…',
      connected: 'Verbunden',
      ended: 'Beendet'
    },
    rootPassword: 'Root-Passwort',
    rootPasswordHint: 'Wird einmal in das kopierte rootfs geschrieben (als Hash, nie wieder angezeigt). Die Images der Distributionen haben kein Root-Passwort: ohne eines ist die Shell der einzige Zugang.',
    sshKeys: 'Öffentliche SSH-Schlüssel für root',
    sshKeysHint: 'Ein öffentlicher OpenSSH-Schlüssel pro Zeile, nach root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Verbindung…',
      connected: 'Verbunden',
      reconnecting: 'Erneute Verbindung…'
    },
    logs: 'Logs',
    logsTitle: 'Logs',
    logsEmpty: 'Keine Ausgabe erfasst.',
    logsSource: 'Welches Log',
    logsSourceConsole: 'Die Init-Konsole des Containers — warum der Dienst darin nicht gestartet ist',
    logsSourceSupervisor: 'Der liblxc-Supervisor — warum der Container es nie bis zum Laufen geschafft hat',
    logsNeverStarted: 'Er wurde nie gestartet, also ist noch nichts aufgezeichnet — starten Sie ihn, und die Logs sind da, auch wenn der Start fehlschlägt.',
    logsNoTemplate: 'Ein Template läuft nie, also hat es nie etwas aufgezeichnet.',
    logsError: 'Die Logs konnten nicht erfasst werden',

    tabs: {
      general: 'Allgemein',
      hardware: 'Hardware',
      network: 'Netzwerk',
      provenance: 'Herkunft'
    },
    templateFlag: 'CT-Template',
    templateLock: 'Ändert sich nur über die Aktionen Befördern / Zurück zum CT — nie eine direkte Bearbeitung.',
    sourceLock: 'Herkunft, bei der Geburt aufgezeichnet — nie umgeschrieben; eine tote Quelle hinterlässt die nackte Referenz.',
    storageLock: 'Bei der Erstellung fixiert — das Verschieben des Rootfs ist ein künftiger Round.',
    startedAt: 'Gestartet',
    lastStop: 'Letzter Stopp',
    editNicsTitle: 'Netzwerke bearbeiten',
    nicDisconnected: 'getrennt'
  },
  ctTemplates: {
    title: 'CT-Templates',
    importAction: 'Aus Katalog importieren',
    importTitle: 'CT-Template aus dem Katalog importieren',
    importSubmit: 'Importieren',
    importError: 'Der Import wurde abgelehnt',
    importHint: 'Das Materialisieren kopiert das Rootfs auf den gewählten Storage — die Katalogdatei bleibt unberührt. Um neue Dateien hinzuzufügen, laden Sie sie zuerst in einen Katalog hoch.',
    sourceFile: 'CT-Template-Datei',
    sourceFileHint: 'Die ct-rootfs-Dateien des gewählten Katalogs, nur die bereiten',
    noFiles: 'Keine bereite ct-rootfs-Datei in diesem Katalog — laden Sie zuerst eine über die Katalogseite hoch',
    source: 'Quelldatei',
    rootfsStorage: 'Rootfs-Storage',
    rootfsStorageHint: "Wo der extrahierte Rootfs-Baum lebt — ein Storage mit Dateisystem und genug freiem Platz für die extrahierte Größe plus etwa 1 GiB Reserve (sonst schlägt der Import fehl).",
    resources: 'Ressourcen',
    cores: 'vCPU',
    memoryMiB: 'Speicher (MiB)',
    cpuLimit: 'CPU-Limit',
    cpuLimitHint: 'Host-Core-Äquivalente (z. B. 1.5); leer = ohne Obergrenze',
    cpuUncapped: 'ohne Obergrenze',
    cpuWeight: 'CPU-Gewicht',
    hostname: 'Hostname',
    hostnameHint: 'Leer = der Name des CT',
    nameservers: 'DNS-Nameserver',
    dnsHint: 'Kommagetrennt; leer = die des Hosts erben',
    searchDomains: 'DNS-Suchdomänen',
    dnsInherited: 'Vom Host geerbt',
    networks: 'Netzwerke',
    nicSlot: 'NIC-Slot',
    phase: {
      materializing: 'Wird materialisiert',
      ready: 'Bereit',
      deleting: 'Wird gelöscht',
      error: 'Fehler'
    },
    exportAction: 'In den Katalog exportieren',
    exportTitle: 'In den Katalog exportieren',
    exportSubmit: 'Exportieren',
    exportError: 'Der Export wurde abgelehnt',
    exportHint: 'Verpackt das materialisierte Rootfs in eine NEUE ct-rootfs-Datei im gewählten Katalog — das Template bleibt unberührt.',
    exportName: 'Dateiname',
    exportNameHint: 'Leer = <template>-export-<n>',
    markCt: {
      action: 'Zurück zum CT',
      confirmTitle: "'{name}' zurück zum CT machen?",
      confirmBody: 'Das Template verlässt diese Liste und kehrt in die CT-Liste zurück, wieder startbar. Bis Sie es erneut befördern, lassen sich daraus keine neuen CTs erstellen.',
      confirm: 'Zurück zum CT',
      moved: "'{name}' ist wieder ein normaler CT — Sie finden ihn in der CT-Liste."
    }
  },
  oci: {
    registriesTitle: 'OCI-Registries',
    imagesTitle: 'OCI-Images',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Generisch',
    providerImmutableHint: 'Der Provider ist nach der Erstellung unveränderlich — ein anderer Provider ist eine neue Registry.',
    url: 'URL',
    urlHintPreset: 'Vom Provider vorbelegt — nur für Mirrors überschreiben.',
    urlHintRequired: 'Pflicht für generische Registries: die https://-Basis-URL.',
    urlHintEcr: 'Pflicht: ECR-Endpoints sind pro Account/pro Region — es gibt kein Preset.',
    credential: 'Zugangsdaten',
    credentialNone: 'Anonymer Zugriff',
    credentialHint: 'Ein Keystore-Eintrag mit Benutzer und Passwort; die Worker lösen ihn im Moment des Gebrauchs auf — nie Auth-Dateien pro Knoten.',
    nameHint: 'Host-artiger Name (docker.io, registry.intra); eindeutig pro Scope, unveränderlich',
    addRegistry: 'Registry hinzufügen',
    addRegistryTitle: 'OCI-Registry hinzufügen',
    verify: 'Verifizieren',
    verifyState: 'Verifizierung',
    verified: 'Verifiziert',
    verifyFailed: 'Fehlgeschlagen',
    neverVerified: 'Nie verifiziert',
    registryInUseError: "'{name}' hat noch registrierte Repositories — löschen Sie diese zuerst.",
    repositories: 'Repositories',
    repositoriesHint: 'Das Registrieren beobachtet die Branches (OCI-Tags) — nichts wird heruntergeladen. Der Refresh löst jeden beobachteten Branch auf und pflegt das Reflog.',
    noRepositories: 'Kein Repository auf dieser Registry registriert.',
    registerRepository: 'Repository registrieren',
    repoPath: 'Pfad',
    repoPathHint: "Pfad des Repositorys auf der Registry, z. B. 'example' oder 'library/nginx'",
    branches: 'Branches',
    branchesHint: 'Beobachtete Branches (OCI-Tags), kommagetrennt — z. B. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'JETZT aufgelöst: Der Pull lädt den Digest herunter, auf den der Branch heute zeigt.',
    refresh: 'Aktualisieren',
    deleteRepository: 'Repository löschen',
    reflogCount: '{n} frühere',
    noResolutions: 'Nie aktualisiert — noch keine Auflösung beobachtet.',
    refreshFailed: 'Letzte Aktualisierung fehlgeschlagen ({when})',
    loadError: 'Die Repositories konnten nicht geladen werden.',
    reference: 'Referenz',
    digest: 'Digest',
    digestHint: 'sha256:… — das exakte Image, ohne Branch (detached)',
    size: 'Größe',
    nodes: 'Knoten',
    detached: 'detached',
    detachedHint: 'Per Digest heruntergeladen, ohne Branch — die Drift-Prüfung greift nicht.',
    pulledAt: 'Heruntergeladen',
    pull: 'Pull',
    pullTitle: 'Image pullen',
    pullHint: 'Pre-Warming, nie eine Voraussetzung: Ein Pull per Branch löst JETZT auf und lädt DIESEN Digest herunter; ein Pull per Digest ist detached.',
    pullError: 'Der Pull wurde abgelehnt',
    pullMode: 'Pull per',
    pullModeBranch: 'Branch (jetzt auflösen)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Der ehrliche Default: Wie bei apt install kann eine spätere Wiederholung ein anderes Image liefern.',
    pullModeDigestHint: 'Exakter Digest — Reproduzierbarkeit und Rollback; verzichtet auf die Drift-Prüfung.',
    importFromRegistry: 'Aus Registry importieren',
    importFromCatalog: 'Aus Katalog importieren',
    importCatalogTitle: 'OCI-Image aus Katalog importieren',
    importCatalogHint: 'Der Air-Gapped-Weg: Ein bereites oci-image-Archiv (tar/tar.gz — docker-archive oder oci-archive) wird mit der Referenz catalog/<katalog>/<datei>@<digest> in den Image-Store materialisiert; die Apps konsumieren es wie jedes andere Image. Die Archive werden in den Katalogen hochgeladen — diese Sektion importiert nur.',
    importCatalogFile: 'Archiv',
    importCatalogFileHint: 'Die bereiten oci-image-Dateien des gewählten Katalogs.',
    importCatalogNoFiles: 'Kein bereites oci-image-Archiv in diesem Katalog — laden Sie eines über das Katalogdetail hoch.',
    importCatalogError: 'Der Import wurde abgelehnt',
    registry: 'Registry',
    repository: 'Repository',
    cacheMissing: 'Der OCI-Cache des Clusters ist nicht konfiguriert — Pulls werden abgelehnt, bis Sie einen Storage-Pool setzen.',
    setCache: 'Cache setzen',
    setCacheTitle: 'Den OCI-Cache konfigurieren',
    setCacheHint: 'Der DEFAULT-Pool auf Cluster-Ebene, der die Blobs der heruntergeladenen Images beherbergt — ein Scope kann ihn mit einem eigenen Pool überschreiben (Seite Scopes). Die Änderung greift nicht im laufenden Betrieb, startet nichts neu und verschiebt keine Blobs: Sie erscheinen lazy beim nächsten Start/Gebrauch wieder.',
    cachePool: 'Storage-Pool',
    changeCache: 'Cache ändern',
    changeCacheTitle: 'Den Pool des OCI-Caches ändern',
    cacheCurrent: 'OCI-Cache des Clusters (Default): {name}',
    sectionOverview: 'Übersicht',
    sectionRepositories: 'Repositories',
    sectionExplore: 'Erkunden',
    exploreHint: 'Eine Remote-Suche live auf der Registry — Docker Hub vollständig (Beschreibung, Downloads, Sterne), andere Provider best-effort. Wählen Sie ein Ergebnis, um die vollständige Beschreibung zu lesen und die Remote-Tags zu durchblättern; von einem Tag aus können Sie die Referenz zu einem TVirt-Repository hinzufügen.',
    exploreSearch: 'Suchen',
    exploreUnsupported: 'Dieser Provider unterstützt die Suche nicht.',
    exploreNoResult: 'Kein passendes Repository.',
    exploreNoTags: 'Kein passender Tag auf diesem Repository.',
    exploreOfficial: 'Offiziell',
    explorePulls: 'Downloads',
    exploreStars: 'Sterne',
    exploreUpdated: 'Aktualisiert {when}',
    exploreLoadMore: 'Mehr laden',
    exploreSelectHint: 'Wählen Sie ein Ergebnis: Vollständige Beschreibung und Remote-Tags laden hier.',
    exploreNoDescription: 'Keine Beschreibung von diesem Provider verfügbar.',
    exploreTagsTitle: 'Remote-Tags',
    exploreTagFilter: 'Tags suchen',
    exploreAddToRepo: 'Zu Repository hinzufügen',
    exploreAdded: '{path}:{tag} wird jetzt verfolgt — siehe die Sektion Repositories.',
    addBranch: 'Branch hinzufügen',
    purgeRequiredTitle: "'{name}' samt seiner Images löschen?",
    purgeRequiredBody: 'Keine App konsumiert dieses Repository, aber heruntergeladene Images existieren noch: Das Löschen entfernt auch deren Einträge, und die gecachten Blobs gehen an die Garbage Collection.',
    purgeConfirm: 'Auch die Images löschen',
    providerSelectHint: 'Wählen Sie den Registry-Typ: Die Karte erzählt Preset und Verwendung.',
    providerDesc: {
      dockerhub: 'Die öffentliche Docker-Registry: URL voreingestellt, vollständige Suche mit Beschreibungen und Zählern.',
      ghcr: 'GitHub Container Registry: URL voreingestellt; Konten verwenden einen Personal Access Token.',
      ecr: 'Amazon Elastic Container Registry: Endpoints pro Konto/Region — die URL muss angegeben werden.',
      quay: 'Die Red-Hat-Quay-Registry: URL voreingestellt.',
      generic: 'Self-hosted Registry (Harbor, registry:2, …): die https://-URL ist Pflicht.'
    },
    layerCount: 'Layer',
    verifiedAt: 'Letzte Verifizierung',
    verifyOk: 'Ergebnis',
    verifyMessage: 'Verifizierungsmeldung',

    // Das Modell #348/R39: das Image IST der Digest — der Inhalt — und Registry, Repository und Branch sind die NAMEN, die ihn erreichen.
    head: 'Head',
    heads: 'Heads je Architektur',
    listDigest: 'Digest der Liste',
    neverResolved: 'Nie aufgelöst',
    totalSize: 'Gesamtgröße',
    reflogTitle: 'Auflösungsverlauf',
    usedBy: 'Verwendet von',
    usageLockfile: 'Lockfile',
    usageRunning: 'läuft',
    evictable: 'verdrängbar',
    evict: 'Aus dem Cache verdrängen',
    evictHeadTitle: '{digest} verdrängen?',
    evictHeadBody: 'Es ist die aktuelle Auflösung mindestens eines Sammlers: das Verdrängen ist legitim — es ist nur Cache, der entfernte Branch liefert ihn weiterhin — darf aber nie versehentlich passieren. Der Blob ist EINER: die Verdrängung leert jeden Sammler, der ihn teilt.',
    evictConfirm: 'Trotzdem verdrängen',

    arch: 'Architektur',
    names: 'Namen',
    noNames: 'kein Name',
    views: 'Views',
    lastView: 'letzte View',
    evictLastViewTitle: 'Die letzte Referenz auf {digest} entfernen?',
    evictLastViewBody: 'Das ist die letzte View auf diesen Inhalt: entfernt man sie, hört das Image auf, auf TVirt zu existieren, und die Bytes ({size}) werden frei. Es ist das docker image rm des Modells — keine Nebenwirkung, sondern die Operation selbst.',
    branchesTabHint: 'Die beobachteten Branches dieses Repositories: je Branch die heutigen Heads — einer je Architektur — die Chronologie der Refreshes und wie viele der von ihm benannten Images im Cache liegen. Der Refresh ist das «git fetch» des Repositories: er löst alle seine Branches auf einmal auf.',
    noBranches: 'Kein Branch auf diesem Repository beobachtet.',
    stopObserving: 'Branch nicht mehr beobachten',
    pullBranch: 'Den Head des Branches in den Cache holen (der Refresh löst auf, dieser lädt herunter)',
    pullDigest: 'Diesen Digest in den Cache holen',
    imageCount: 'Images',
    deleteBranchPurgeTitle: 'Die Images von {name} ohne Namen lassen?',
    deleteBranchPurgeBody: 'Keine App benennt diesen Branch, aber einige Images werden nur über ihn erreicht: löscht man ihn, bleiben sie ohne Namen im Cache, gelistet bei den Images des Repositories und von Hand verdrängbar.',
    deleteBranchPurgeConfirm: 'Löschen und Images ohne Namen lassen',
    imagesTabHint: 'Die Images dieses Repositories — die Inhalte, also die Digests — auch ohne Auswahl eines Branches sichtbar. Ein Image ist clusterweit eindeutig: die Namen, die es erreichen, können mehrere sein.',
    noImages: 'Kein Image dieses Repositories ist im Cache materialisiert.',
    deleteRepositoryTitle: '{name} löschen?',
    deleteRepositoryBody: 'Das Repository und seine Branches verschwinden samt Chronologie. Die Images bleiben im Cache: sie verlieren nur diesen Namen. Ein Repository, das eine App benennt, lässt sich nicht löschen.',
    provenanceCatalog: 'Katalog',
    refreshedAt: 'Aktualisiert',
    neverRefreshed: 'Nie aktualisiert',
    sectionBranches: 'Branches',
    sectionImages: 'Images',
    repositoriesGovernedElsewhere: 'Hier werden Repositories nur angesehen: registrieren, aktualisieren, Branches beobachten und Images verdrängen geschieht im Bereich OCI-Images.',
    gotoImages: 'Zu OCI-Images'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pods',
    containers: 'Container',
    instances: 'Instanzen',
    instancesTooltip: '{running} laufend, {error} fehlerhaft',
    placement: 'Platzierung',
    spread: 'Verteilung',
    ha: 'HA',
    templateRevision: 'Revision',
    deleting: 'Wird gelöscht',
    empty: 'Keine Pods — eine App (ein Container) oder einen Pod über die CLI (create-pod) erstellen.',
    openInstances: 'Instanzen öffnen',
    rollingRestart: 'Rollierender Neustart',
    scale: 'Skalieren',
    scaleTitle: '{name} skalieren',
    scaleHint: 'Anzahl der Instanzen (0–64): aufwärts wird die niedrigste freie Ordnungszahl belegt, abwärts die höchste zurückgezogen — ihre persistenten Daten bleiben.',
    scaleError: 'Skalierung fehlgeschlagen',
    replicas: 'Replikate',
    deleteRunningError: '{name} läuft — zuerst stoppen.',
    deleteInstancesIntro: 'Alle {count} Instanzen werden entfernt.',
    stateRunning: 'Läuft',
    stateStopped: 'Gestoppt',
    editor: {
      createTitle: 'Pod erstellen',
      create: 'Pod erstellen',
      editTitle: 'Pod bearbeiten',
      nameHint: 'DNS-1123, höchstens 58 Zeichen — die Instanzen heißen <name>-<index>; nach dem Erstellen unveränderlich.',
      restartPolicy: 'Restart-Policy',
      restartPolicyHint_always: 'Der Knoten startet jeden beendeten Container neu, mit exponentiellem Backoff (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Nur ein Container mit Exit-Code ungleich null wird neu gestartet; Exit 0 bleibt ruhen.',
      restartPolicyHint_never: 'Ein beendeter Container bleibt wie er ist — die Instanz endet als succeeded oder failed.',
      grace: 'Karenz (s)',
      graceHint: 'Die SIGTERM → SIGKILL-Grenze eines Stopps.',
      hostname: 'Hostname',
      hostnameHint: 'Leer = der Instanzname.',
      hostnameDefault: 'der Instanzname',
      sharePid: 'PID-Namespace zwischen den Containern teilen',
      containersIntro: 'Init-Container laufen der Reihe nach bis zum Ende, bevor die Container starten; die Container teilen das Netz der Instanz (eine IP, localhost untereinander).',
      initContainers: 'Init-Container',
      initAdd: 'Init-Container hinzufügen',
      initHint: 'Jeder muss mit 0 enden; ein Fehlschlag setzt die Instanz auf Fehler und der Knoten wiederholt ihn mit Backoff.',
      containerAdd: 'Container hinzufügen',
      atLeastOne: 'Ein Pod braucht mindestens einen Container.',
      duplicateNames: 'Container-Namen müssen im Pod eindeutig sein (Init-Container eingeschlossen).',
      containerName: 'Container-Name',
      containerInvalid: 'Dieser Container ist unvollständig: Name (DNS-1123), Image, Mounts auf deklarierten Volumes, numerische Limits und Probe.',
      command: 'Befehl',
      commandHint: 'Überschreibt den Entrypoint des Images — ein Argument pro Zeile, nie ein Shell-String.',
      args: 'Argumente',
      argsHint: 'Eines pro Zeile (das CMD des Images, wenn leer).',
      mounts: 'Mounts',
      mountAdd: 'Mount hinzufügen',
      mountNoVolumes: 'Zuerst ein Volume im Tab Storage deklarieren.',
      readOnly: 'schreibgeschützt',
      resources: 'Limits',
      cpus: 'CPUs',
      cpusHint: 'podman --cpus (z. B. 1.5)',
      memory: 'Speicher (MiB)',
      memoryHint: 'podman --memory',
      health: 'Liveness-Probe',
      healthCmd: 'Probe-Befehl',
      healthCmdHint: 'Vom Knoten bei jedem Überwachungstakt im Container ausgeführt — ein Argument pro Zeile; Exit 0 = gesund.',
      healthTimeout: 'Timeout (s)',
      healthRetries: 'Versuche',
      healthRetriesHint: 'Aufeinanderfolgende Fehlschläge, bevor der Knoten den Container neu startet.',
      ips: 'Statische Adressen',
      ipsHint: 'Eine pro Instanz, in Ordnungszahl-Reihenfolge — eine Skalierung über die Liste hinaus wird abgelehnt.',
      instance: 'Instanz',
      volumesHint: 'Volumes gehören dem Pod; der Mount-Pfad gehört jedem Container (Tab Container).',
      spread: 'Verteilung',
      spreadHint_preferred: 'Instanzen nach Möglichkeit auf verschiedenen Knoten.',
      spreadHint_required: 'Instanzen auf verschiedenen Knoten, sonst lehnt die Skalierung ab.',
      spreadHint_none: 'Nur der Entscheider.',
      ha: 'Hochverfügbarkeit (Opt-in)',
      haHint: 'Jedes persistente Stück auf geteiltem Storage; stirbt der Knoten, erzeugt der HA-Decider die Instanzen auf einem anderen Mitglied neu (automatisches Failover, wie bei HA-VMs).',
      yes: 'ja',
      no: 'nein'
    },
    detail: {
      container: 'Container',
      actions: 'Aktionen',
      ready: 'Bereit',
      notReady: 'Nicht bereit',
      restarts: 'Neustarts',
      lastRestartAt: 'Letzter Neustart:',
      backoffUntil: 'Erneut um',
      stateAbsent: 'fehlt',
      stateRunning: 'läuft',
      stateTerminated: 'beendet',
      stateWaiting: 'wartet',
      init: 'init',
      noInstances: 'Keine Instanzen (Replikate 0).',
      ha: 'HA',
      haHint: 'Automatisches Failover: stirbt der Knoten, erzeugt der HA-Decider die Instanz auf einem anderen Mitglied neu (jedes persistente Stück auf geteiltem Storage).',
      authority: 'Authority (Knoten)',
      homeless: 'ohne Authority',
      homelessHint: 'Eine Wiederherstellung aus dem Checkpoint lässt die Authority weg (#380): kein Knoten bedient sie, bis der Pod skaliert wird (auch auf dieselbe Replikazahl).',
      restartContainer: 'Nur diesen Container neu starten (der Pod bleibt oben)',
      divergingHint: 'Der gewünschte Zustand dieser Instanz weicht vom Standard des Pods ab (PD-P19).',
      revisionLag: 'Revision {applied} angewendet von {current}',
      updatedInstances: '{updated}/{desired} Instanzen auf dieser Revision'
    }
  }
}
